export const CART_QUANTITY = {
  increase: 'increase',
  decrease: 'decrease',
} as const;

type ObjectValues<T> = T[keyof T];
export type CartQuantityType = ObjectValues<typeof CART_QUANTITY>

